import { Utils } from '../utils';
import { CustomTypedEvent } from '../events';
export var SwipeEventType;
(function (SwipeEventType) {
    SwipeEventType["Swipe"] = "swipe";
    SwipeEventType["Pan"] = "pan";
    SwipeEventType["SwipeLeft"] = "swipeleft";
    SwipeEventType["SwipeRight"] = "swiperight";
    SwipeEventType["SwipeUp"] = "swipeup";
    SwipeEventType["SwipeDown"] = "swipedown";
    // end of swipe animation
    SwipeEventType["SwipeAnimationEnd"] = "swipeanimationend";
    SwipeEventType["SwipeLeftAnimationEnd"] = "swipeleftanimationend";
    SwipeEventType["SwipeRightAnimationEnd"] = "swiperightanimationend";
    SwipeEventType["SwipeUpAnimationEnd"] = "swipeupanimationend";
    SwipeEventType["SwipeDownAnimationEnd"] = "swipedownanimationend";
})(SwipeEventType || (SwipeEventType = {}));
export class SwipeEventArgsClass {
    constructor(_builder) {
        this._builder = _builder;
    }
    get #isVertical() {
        const { verticalspeed, horizontalspeed, vertical } = this._builder;
        const isVertical = vertical ?? (Math.abs(horizontalspeed) < Math.abs(verticalspeed));
        return isVertical;
    }
    get direction() {
        return this.#isVertical
            ? (this._builder.verticalspeed > 0 ? 'down' : 'up')
            : (this._builder.horizontalspeed > 0 ? 'right' : 'left');
    }
    /** Speed in pixels/second, with sign. */
    get speed() {
        const { verticalspeed, horizontalspeed } = this._builder;
        return this.#isVertical ? verticalspeed : horizontalspeed;
    }
    /** Current offset relative to element's original position. */
    get delta() {
        const { position: { x, y }, t0: { position: { x: x0, y: y0 } } } = this._builder;
        return this.#isVertical
            ? y - y0
            : x - x0;
    }
    get flinging() {
        const { fling } = this._builder;
        return fling > 0 && Math.abs(this.speed) > fling;
    }
    /** Final offset (relative to element's original position) that takes release velocity into account. */
    get predictedDelta() {
        const inertia = this._builder.inertia ?? 8;
        return this.delta + this.speed / inertia;
    }
    /** Seconds to reach the final predicted position. */
    get predictedDuration() {
        const inertia = this._builder.inertia ?? 8;
        return -Math.log(.01 /* v/v0 where v ~ 0 <=> 1% of v0 */) / inertia;
    }
    get element() {
        return this._builder.element;
    }
    static fromArgs(builder) {
        return new SwipeEventArgsClass(Utils.extend({}, builder));
    }
}
export class SwipeEvent extends CustomTypedEvent {
    constructor(type, args, eventInit) {
        super(type, args, eventInit);
    }
}
//}
